import { formatNumber } from "../data/essential";
import moment from "moment";
import CountdownTimer from "../../Component/Timer";
const style = { color: "#FFF" };
export const reconciliationDetailsColumns = [
  {
    name: <div style={style}>Operator</div>,
    cell: () => `Galaxy group`,
  },
  {
    name: (
      <div style={style}>
        Reconc-
        <br />
        iliation
        <br />
        Month
      </div>
    ),
    cell: (row) => row["reconciliationPeriod"],
    width: "80px",
  },
  {
    name: (
      <div style={style}>
        {" "}
        Scheduled
        <br /> Transfer
        <br />
        Time
      </div>
    ),
    cell: (row) =>
      moment(row["transferScheduledDate"]).format("DD-MM-YYYY H:mm:ss A"),
  },
  {
    name: <div style={style}> Collections</div>,
    cell: (row) => formatNumber(row["totalCollectionAmount"]),
    width: "102px",
  },
  {
    name: <div style={style}>Commission</div>,
    cell: (row) => formatNumber(row["totalCommissionAmount"]),
    width: "110px",
  },
  {
    name: (
      <div style={style}>
        Disbur-
        <br />
        sement
      </div>
    ),
    cell: (row) => formatNumber(row["totalDisbursementAmount"]),
  },
  {
    name: <div style={style}>Transfered</div>,
    cell: (row) => formatNumber(row["totalTransferedAmount"]),
  },
  {
    name: <div style={style}>Refunded</div>,
    cell: (row) => formatNumber(row["totalRefundedAmount"]),
  },
  {
    name: (
      <div style={style}>
        Collection
        <br /> Fee
      </div>
    ),
    cell: (row) => formatNumber(row["momoCollectionFeeAmount"]),
  },
  {
    name: <div style={style}>To be Paid</div>,
    cell: (row) => formatNumber(row["totalTobepaidAmount"]),
  },
  {
    name: <div style={style}>Paid</div>,
    cell: (row) => formatNumber(row["totalPaidAmount"]),
  },
  {
    name: <div style={style}>Transfer Id</div>,
    cell: (row) => row["transferId"],
  },
  {
    name: <div style={style}>Status</div>,
    cell: (row) => row["status"]["name"],
  },
  {
    name: <div style={style}>Time Left</div>,
    cell: (row) => {
      const targetDate = new Date(row?.transferScheduledDate);
      targetDate.setDate(targetDate.getDate());
      return (
        <div>
          <CountdownTimer targetDate={targetDate} />
        </div>
      );
    },
  },
];
